/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: CA
 *| (C) Copyright IBM Corp. 2018
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'../../widgets/livewidget/nls/StringResources',
	'underscore'
], function (BaseClass, StringResources, _) {
	'use strict';

	/**
	 * Class to open content dialog and to pick a drill through target.
	 */
	var SelectDrillTargetActionHandler = BaseClass.extend({
		init: function (dashboardApi) {
			SelectDrillTargetActionHandler.inherited('init', this, arguments);
			this.dashboardApi = dashboardApi;
		},

		/**
		 * This method will show an open dialog to select a drill target.
		 */
		selectTarget: function (context) {
			context = context || {};
			if (!context.handlers || !context.handlers.onSelect) {
				throw new Error('onSelect handler must be provided');
			}

			const typesToOpen = ['report', 'reportView', 'exploration'];

			var options = {
				'typesToOpen': typesToOpen,
				'dataManipulationCallback': this._filterOutExploration.bind(this),
				'extraUrlParameters': ['base'],
				'multiSelect': false,
				'dialogTitle': StringResources.get('selectTargetDialogTitle'),
				'primaryBtnText': StringResources.get('dlg_ok'),
				'onOpenCallback': (selectedItems) => {
					this._addDrillTarget(context.handlers.onSelect, selectedItems);
				}
			};

			this.dashboardApi.prepareGlassOptions(options);

			try {
				return this._selectTargetFromOpenDialog(options);
			} catch (error) {
				throw new Error(error);
			}
		},

		/**
		 * The open dialog should contain dashboards, stories and reports.
		 * However, the 'typesToOpen' value 'exploration' includes explorations, dashboards and stories.
		 * Filtering manually here is the only way offered by ContentNav to achieve this.
		 */
		_filterOutExploration: function (response) {
			if(response.data && response.data.length) {
				response.data = response.data.filter((result) => {
					return !result.tags ||
						result.type !== 'exploration' ||
						result.tags.includes('dashboard') ||
						result.tags.includes('story');
				});
			}
		},

		_selectTargetFromOpenDialog: function(options) {
			return this.dashboardApi.getGlassSvc('.ContentDialogFactory').then((dialogFactory) => {
				return new Promise((resolve, reject) => {
					var openDialog = dialogFactory.createOpenDialog({
						...options,
						resolve,
						reject
					});
					openDialog.open();
				});
			});
		},

		/**
		 *  @param selectedItems  - an array of CM object items. When multiSelect is false, the array has only one selected item
		 */
		_addDrillTarget: function(callback, selectedItems) {
			// There is only 1 selected item in this function because multiSelect is set to false
			var selectedItem = selectedItems[0];
			let perspective = 'authoring';
			if(selectedItem.type === 'exploration') {
				perspective = selectedItem.tags.includes('story') ? 'story' : 'dashboard';
			}
			var drillTarget = {
				'assetId': selectedItem.id,
				'name': selectedItem.defaultName,
				'type': selectedItem.type,
				'searchPath': selectedItem.searchPath,
				'isOlapPackage': selectedItem.userInterfaces && _.indexOf(selectedItem.userInterfaces, 'analysisStudio') >= 0,
				'modificationTime': selectedItem.modificationTime,
				'perspective': perspective
			};
			callback(drillTarget);
		}
	});

	return SelectDrillTargetActionHandler;
});
